module.exports = ".print-contract-buttons-container {\n    margin-top: 15px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n        -ms-flex-pack: end;\n            justify-content: flex-end;\n}\n\n.print-contract-buttons-container button {\n    margin-right: 15px;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/contract-generate/contract-generate.component.css
// module id = ./src/app/contract-generate/contract-generate.component.css
// module chunks = main